import css from './Header.module.css'
import Card from "@/shared/components/common/Card/Card"
import DashboardDatesGroup from "../../../Dashboard/components/dashboardDatesGroup"
import PlanActionsButton from "../_common/planActionsButton/PlanActionsButton"
import DashboardDepartment from '@/features/Sale/Dashboard/components/dashboardDepartment'
import { useState } from 'react'
import { useAuth } from '@/features/Auth/lib/useAuth'
import { useAuthActions } from '@/features/Auth/lib/useAuthActions'
import { useDashboard } from '@/features/Sale/Dashboard/lib/useDashboard'
import { toLocalDateString, getPreviousRangeDates, getNextRangeDates } from '@/shared/lib/dates'
import { Button } from '@/shared/components/common/Button/Button'
import { useIsMobile } from '@/shared/lib/useIsMobile'
import { isSalesSystemAccount } from '@/features/Auth/lib/salesAccess'

function getCurrentWeekRange(): { start: Date; end: Date } {
  const now = new Date()
  const dayOfWeek = now.getDay() // 0=Вс, 1=Пн, ...
  const daysFromMonday = (dayOfWeek + 6) % 7
  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() - daysFromMonday)
  const sunday = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + 6)
  return { start: monday, end: sunday }
}

function getCurrentMonthRange(): { start: Date; end: Date } {
  const now = new Date()
  const start = new Date(now.getFullYear(), now.getMonth(), 1)
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
  return { start, end }
}

function getCurrentQuarterRange(): { start: Date; end: Date } {
  const now = new Date()
  const quarter = Math.floor(now.getMonth() / 3)
  const start = new Date(now.getFullYear(), quarter * 3, 1)
  const end = new Date(now.getFullYear(), quarter * 3 + 3, 0)
  return { start, end }
}

function getCurrentYearRange(): { start: Date; end: Date } {
  const now = new Date()
  const start = new Date(now.getFullYear(), 0, 1)
  const end = new Date(now.getFullYear(), 11, 31)
  return { start, end }
}

function Header() {
  const [isLoggingOut, setIsLoggingOut] = useState(false)
  const { user } = useAuth()
  const { logout } = useAuthActions()
  const { dateStart, dateEnd, setDateStart, setDateEnd } = useDashboard()
  const isMobile = useIsMobile()
  const flag = (user?.bx?.sub_users?.length ?? 0) > 0
  const systemAccount = isSalesSystemAccount(user)
  const canOpenPlans = flag || systemAccount || !!user?.is_admin || Number(user?.bx?.bx_user?.bx_id) === 8 ||
    !!user?.bx?.department?.some(d => d.role === 'head')

  const setPeriod = (range: { start: Date; end: Date }) => {
    const startStr = toLocalDateString(range.start)
    const endStr = toLocalDateString(range.end)
    setDateStart(startStr)
    setDateEnd(endStr)
    localStorage.setItem('dateStart', startStr)
    localStorage.setItem('dateEnd', endStr)
  }

  const shiftPeriod = (direction: 'prev' | 'next') => {
    if (!dateStart || !dateEnd) return
    const fn = direction === 'prev' ? getPreviousRangeDates : getNextRangeDates
    const next = fn(dateStart, dateEnd)
    if (next) {
      setDateStart(next.dateStart)
      setDateEnd(next.dateEnd)
      localStorage.setItem('dateStart', next.dateStart)
      localStorage.setItem('dateEnd', next.dateEnd)
    }
  }

  return (
    <div className={css.headerWrapper}>
      <Card>
        <div className={css.header}>
          <div className={css.headerLeft}>
            <div className={css.periodNav}>
              <Button
                variant="secondary"
                size="s"
                onClick={() => shiftPeriod('prev')}
                disabled={!dateStart || !dateEnd}
                title="Предыдущий период"
              >
                ←
              </Button>
              <DashboardDatesGroup/>
              <Button
                variant="secondary"
                size="s"
                onClick={() => shiftPeriod('next')}
                disabled={!dateStart || !dateEnd}
                title="Следующий период"
              >
                →
              </Button>
            </div>
            <div className={css.periodButtons}>
              <Button variant="secondary" size="s" onClick={() => setPeriod(getCurrentWeekRange())}>
                Неделя
              </Button>
              <Button variant="secondary" size="s" onClick={() => setPeriod(getCurrentMonthRange())}>
                Месяц
              </Button>
              <Button variant="secondary" size="s" onClick={() => setPeriod(getCurrentQuarterRange())}>
                Квартал
              </Button>
              <Button variant="secondary" size="s" onClick={() => setPeriod(getCurrentYearRange())}>
                Год
              </Button>
            </div>
          </div>
          {isMobile ? null : (
            <div className={css.headerRight}>
              {(flag || systemAccount) && <DashboardDepartment/>}
              {canOpenPlans && <PlanActionsButton/>}
              <Button
                variant="secondary"
                size="s"
                type="button"
                disabled={isLoggingOut}
                onClick={async () => {
                  if (isLoggingOut) return
                  setIsLoggingOut(true)
                  await logout()
                }}
                title="Выйти"
              >
                Выйти
              </Button>
            </div>
          )}
        </div>
        {isMobile && canOpenPlans && <div className={css.mobileActions}>
          {(flag || systemAccount) && <DashboardDepartment/>}
          <PlanActionsButton/>
        </div>}
      </Card>
    </div>

  )
}

export default Header
